import { UserType } from "@mcleod/core";
import { DataSource } from "@mcleod/components";
import { AutogenLayoutUserTableCustomer } from "./autogen/AutogenLayoutUserTableCustomer";
import { UserTableController  } from "./UserTableController";
import { UserTableLayout } from "./UserTableLayout";

export class UserTableCustomer extends AutogenLayoutUserTableCustomer implements UserTableLayout {
    public getSourceUsers(): DataSource {
        return this.sourceUserSettings;
    }

    public getUserType(): UserType {
        return UserType.CUSTOMER;
    }

    override onLoad(): void | Promise<void> {
        new UserTableController(this);
    }
}
